import fullscreenicon from "./fullscreenpreview_button_24px.png";

export const FullScreenIcon = () => (
  <img src={fullscreenicon} alt="Full screen icon" />
);
